module.exports = __webpack_public_path__ + "img/stoxos.8d8e627f.png";